/** @format */

export const getDesktopTypeaheadSearchButtonDisplayValue = (
    hasSearchValue: boolean
) => (hasSearchValue ? 'none' : 'flex');

export const getSmallTabletSearchBarDisplayValue = (isOpen: boolean) =>
    isOpen ? 'flex' : 'none';

export const getSmallTabletSearchButtonDisplayValue = (isOpen: boolean) =>
    isOpen ? 'none' : 'flex';
